import { GridRow, Button, useIntl } from "@metsooutotec/modes-react-components";
import { FC } from "react";

interface DialogButtons {
    isLoading?: boolean;
    onCloseProcess: () => void;
    handleSubmit: (e: React.FormEvent) => Promise<void>; 
}

const ModalsButtons: FC<DialogButtons> = ({ isLoading, onCloseProcess, handleSubmit }) => {
    const { formatMessage } = useIntl();

    const labels = {
        confirm: formatMessage("modal.confirm"),
        cancel: formatMessage("modal.cancel"),
    };

    const buttonsConfig = [
        { label: labels.confirm, onClick: handleSubmit, primary: true },
        { label: labels.cancel, onClick: onCloseProcess, primary: false },
    ];

    return (
        <>
            <div style={{ marginBottom: "var(--size-xxl)" }} />
            {
                buttonsConfig.map((button, index) => {
                    const { label, onClick, primary } = button;
                    const buttonGridStyle = index === 0 ? {
                        marginBottom: "var(--size-m)"
                    } : {};
                    return (
                        <GridRow key={label} style={buttonGridStyle}>
                            <Button
                                loading={isLoading}
                                disabled={isLoading}
                                onClick={onClick}
                                flexible={true}
                                children={label}
                                centered
                                size={'medium'}
                                primary={primary}
                            />
                            </GridRow>
                    );
                })
            }
        </>
    );
}
export default ModalsButtons;
